<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			<div class="modal__head">
				<div class="modal__head__title">Base Mapping</div>
				<div class="modal__head__subtitle">Add a base map to your survey.</div>
			</div>
			<div class="modal__content">
				<ul>
					<div class="col md-12">
						<div class="modal__content--sml">
						Though not compulsory, we can incorporate Ordnance Survey mapping around your site to provide context to your survey, a price will be included within your quote. Alternatively upload your own data.
						</div>
					</div>
				</ul>
				<div class="clearfix"></div>
				<button class="primary" @click="closeModaler">Close</button>
			</div>
		</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'BaseMappingModal',
			}
		},
		methods : {
			closeModaler(){
				return this.$store.commit('closeModal', '');
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/BaseMappingModal.vue